import { AccountItemSchema } from "@/schemas/account/account-item";
import { DeploymentLicenseItemSchema } from "@/schemas/deployment/deployment-license-item";
import { z } from "zod";

export const DeploymentAccountItemSchema = z.object({
  Id: AccountItemSchema.shape.Id,
  Name: AccountItemSchema.shape.Name,
  Licenses: DeploymentLicenseItemSchema.array(),
});

export type DeploymentAccountItemType = z.infer<
  typeof DeploymentAccountItemSchema
>;
